import { SVGProps, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { centerTextHorizontally } from '../../../utils/svgUtils';

const LeftPlayButton = (props: SVGProps<SVGSVGElement>) => {
  const { color } = props;
  const { t } = useTranslation();

  const textRef = useRef<SVGTextElement>(null);

  useEffect(() => {
    const svgWidth = 150.24; // Assuming fixed SVG width based on viewBox
    centerTextHorizontally(textRef, svgWidth);
  }, [t]);

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150.24 150.24"
      {...props}
    >
      <g id="Rectangle_1888" data-name="Rectangle 1888">
        <rect x="19.24" y="19" width="112" height="112" rx="11" fill="#fff" />
        <path
          d="M120.24,131h-90a11,11,0,0,1-11-11V30a11,11,0,0,1,11-11h90a11,11,0,0,1,11,11v90A11,11,0,0,1,120.24,131Zm-90-110a9,9,0,0,0-9,9v90a9,9,0,0,0,9,9h90a9,9,0,0,0,9-9V30a9,9,0,0,0-9-9Z"
          fill={color ? color : '#cacaca'}
        />
      </g>
      <path
        id="Polygon_9"
        data-name="Polygon 9"
        d="M87.65,60.37a4,4,0,0,1,0,6.83L72.32,76.56a4,4,0,0,1-6.08-3.41V54.41A4,4,0,0,1,72.32,51Z"
        fill={color ? color : '#cacaca'}
      />
      <text
        ref={textRef}
        x="0"
        y="105"
        fontWeight="bold"
        fontFamily="Nunito"
        letterSpacing="0.5px"
        fill={color ? color : '#cacaca'}
      >
        {t('trackers:breastfeedingScreen:buttons.left')}
      </text>
    </svg>
  );
};

export default LeftPlayButton;
